export const SET_LANDING_PAGE_IMAGES = "SET_LANDING_PAGE_IMAGES";
export const SET_HIDE_LANDING_PAGE = "SET_HIDE_LANDING_PAGE ";
export const SET_FINISHED_SCROLLING = "SET_FINISHED_SCROLLING";
export const SET_IS_DATA_LOADED = "SET_IS_DATA_LOADED";
export const SET_LANGUAGE = "SET_LANGUAGE";
